import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { useConversion } from 'hooks';
import { getHeightStyle } from './helpers';
import styles from './GlucoseConcentrationLevels.pcss';
const ScaleValues = ({ glucoseConcentrationLevels, isNotingActive, onAddLevelNote })=>{
    const conversion = useConversion('bloodGlucoseConcentration');
    return /*#__PURE__*/ _jsx("div", {
        className: styles.scaleContainer,
        children: glucoseConcentrationLevels.map((lvl, idx)=>{
            let topThreshold = conversion.toDisplay(lvl.topThreshold);
            if (!idx) {
                topThreshold = Math.ceil(topThreshold);
            }
            return /*#__PURE__*/ _jsx("a", {
                href: "",
                className: cn(styles.segment, styles.scaleValue, {
                    activeNoting: isNotingActive
                }),
                style: getHeightStyle(lvl),
                onClick: (evt)=>onAddLevelNote(evt, lvl),
                children: topThreshold
            }, `barRange-${lvl.name}`);
        })
    });
};
export default ScaleValues;
